'use client';

import { useCallback } from 'react';

import { useCurrentUserId } from '@ps/ui/contexts/auth';

import { togglePinMessage } from '../functions/message/togglePinMessage';

/**
 * Toggle pin/un-pin on a message. The current `pinnedAt` on the
 * message tells us which direction we're flipping — callers pass it
 * in (typically `message.pinnedAt != null`).
 */
export function useTogglePinMessage({
  channelId,
  messageId,
}: {
  channelId: string | null | undefined;
  messageId: string | null | undefined;
}) {
  const creatorId = useCurrentUserId();
  return useCallback(
    async ({ currentlyPinned }: { currentlyPinned: boolean }) => {
      if (!creatorId || !channelId || !messageId) return;
      await togglePinMessage({
        creatorId,
        channelId,
        messageId,
        remove: currentlyPinned,
      });
    },
    [creatorId, channelId, messageId],
  );
}
